'use client';

import { Typography } from 'lighthouse';

import { ShelfTabsProps } from './models';

const ACTIVE_CLASS = { light: 'bg-white text-primary shadow-sm', dark: 'bg-white text-slate-950 shadow-sm' };
const IDLE_CLASS = {
    light: 'bg-transparent text-blackMediumEmphasis hover:text-blackHighEmphasis',
    dark: 'bg-transparent text-white/70 hover:text-white'
};

export const ShelfTabs = <T extends { id: string; label: string }>({ label, tabs, activeId, onSelect, dark = false }: ShelfTabsProps<T>) => {
    const theme = dark ? 'dark' : 'light';

    return (
        <div role='group' aria-label={label} className='nice-scroll -mx-4 overflow-x-auto px-4 md:mx-0 md:overflow-visible md:px-0'>
            <div className={`inline-flex min-w-max gap-1 rounded-2xl p-1 ${dark ? 'bg-white/10' : 'bg-N100'}`}>
                {tabs.map((tab) => {
                    const isActive = tab.id === activeId;

                    return (
                        <button
                            type='button'
                            key={tab.id}
                            aria-pressed={isActive}
                            onClick={() => onSelect(tab)}
                            className={`min-h-10 cursor-pointer whitespace-nowrap rounded-xl border-0 px-4 transition-all duration-200
                            focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary
                            motion-reduce:transition-none ${isActive ? ACTIVE_CLASS[theme] : IDLE_CLASS[theme]}`}>
                            <Typography variant='body2' component='span' fontWeight={isActive ? 700 : 500} className='leading-6 text-current'>
                                {tab.label}
                            </Typography>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};
